// Global configuration for marketing integrations and defaults

// Default Google Tag Manager container ID
export const DEFAULT_GTM_ID = "GTM-NGV624ZG";

// CTA URL domain whitelist (supports wildcard by suffix matching)
// Any subdomain of these apex domains is allowed.
export const CTA_DOMAIN_WHITELIST: string[] = [
  "redgo.top",
  "jump2.top",
  "goany.top",
  "gomuse.xyz",
  "geogo.top",
  "directapp.top",
  "gopurp.top",
  "messenger.com",
  "api.whatsapp.com",
  "resopo.xyz",
  "gopyso.xyz",
  "tonyderz.top",
  "louigo.top",
  "foxisgo.top",
  "jakeygoes.top",
  "intiaco.top",
  "cojare.top",
  "dastihm.top",
  "otrgib.shop",
];

// Helper to get active GTM ID (can be customized to read from env later)
export function getGtmId(): string {
  // Prefer Vite env if provided, else default
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const envId = (import.meta as any)?.env?.VITE_GTM_ID;
  return envId || DEFAULT_GTM_ID;
}
